<template>
  <b-button class="print-labels-button" @click="openDownloadLabelsModal">
    <i class="fa fa-print" />
  </b-button>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent } from 'vue'
import { useDownloadLabelsAction } from '@/composables/Labels/useDownloadLabelsAction'

export default defineComponent({
  name: 'LabelsButton',
  props: {
    assignments: {
      type: Array<Assignment>,
      required: true,
    },
  },
  setup({ assignments }) {
    const downloadLabelsAction = useDownloadLabelsAction()

    const openDownloadLabelsModal = () => downloadLabelsAction(assignments)

    return {
      openDownloadLabelsModal,
    }
  },
})
</script>
